import { Component, Input } from '@angular/core';
import { ViewStock } from 'src/app/models/enums/ViewStock.enum';
import { Price } from 'src/app/models/types/Product/Price.type';
import { ProductDetailPageDTO } from 'src/app/models/types/Product/Product.type';
import { BatchStockDTO, CompaniesWithBatchStocks, CompaniesWithStoreStocks, HEWBatchStockDTO, StocksDTO } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { MultiRowTextEllipsisComponent } from '../../multi-row-text-ellipsis/multi-row-text-ellipsis.component';
import { BatchStockComponent } from '../batch-stock/batch-stock.component';
import { HewStockComponent } from '../hew-stock/hew-stock.component';
import { PdpService } from '../pdp.service';
import { GlobalHqStockComponent } from '../view-stock/global-hq-stock/global-hq-stock.component';
import { HqBatchStockComponent } from '../view-stock/hq-batch-stock/hq-batch-stock.component';
import { HqStockComponent } from '../view-stock/hq-stock/hq-stock.component';
import { ViewStockComponent } from '../view-stock/view-stock.component';

@Component({
  selector: 'app-stock',
  imports: [
    MultiRowTextEllipsisComponent,
    ViewStockComponent,
    BatchStockComponent,
    HewStockComponent,
    HqStockComponent,
    HqBatchStockComponent,
    GlobalHqStockComponent,
    SharedModule
  ],
  templateUrl: './stock.component.html',
  styleUrl: './stock.component.scss'
})
export class StockComponent {

  @Input('viewStockType') viewStockType!: ViewStock;
  @Input('pdp') pdp!: ProductDetailPageDTO | null;
  @Input('price') price!: Price | null | undefined;
  @Input('stock') stock!: StocksDTO | null;
  @Input('batchStock') batchStock!: BatchStockDTO | null;
  @Input('hewStock') hewStock!: HEWBatchStockDTO | null;
  @Input('hqStock') hqStock!: CompaniesWithStoreStocks | null;
  @Input('hqBatchStock') hqBatchStock!: CompaniesWithBatchStocks | null;
  @Input('loading') loading!: boolean;

  public get showStock(): boolean {
    return !!(this.stock || this.batchStock || this.hewStock || this.hqStock || this.hqBatchStock || this.showGlobalHqStock);
  }

  public get includingTaxes(): boolean {
    return !!this.price?.tax;
  }

  public get priceLabel(): string {
    return this.sharedService.getPriceLabel(this.price);
  }

  public get canShowPrice(): boolean {
    return !!this.authService.user?.isUserStore;
  }

  public get showGlobalHqStock(): boolean {
    let isStockAvailable = this.pdpService.globalAreasStock() || this.pdpService.globalAreasBatchStock();
    return !!isStockAvailable;
  }

  constructor(
    private readonly sharedService: SharedService,
    private readonly authService: AuthService,
    public readonly pdpService: PdpService,
  ) {}
}
